var app = angular.module('leonardo');

var RulePropertySelector = function(ngDialog, FilterService, FieldService) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      filter: '@',
      name: '@',
      inline: '=',
      placeholder: '@',
      options: '='
    },
    templateUrl: 'views/templates/widget/rule-selector.html',
    link: function (scope, element, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];
      scope.formCtrl = scope.$parent.Form ? scope.$parent.Form : { '$submitted' : true };
      scope.value = '';
      scope.dynamic_filters = [];
      scope.init = false;

      scope.placeholder = !isNull(scope.placeholder) ? scope.placeholder : 'Select Rules';

      scope.fieldService = FieldService;

      scope.ngModelCtrl.$render = function () {
        scope.lookup_filters = scope.ngModelCtrl.$viewValue;
        if (isNull(scope.lookup_filters) && scope.filter) {
          scope.lookup_filters = FilterService.getFilter(scope.filter);
        }
        scope.lookup_filters = !isNull(scope.lookup_filters) ? scope.lookup_filters : [];
      };

      scope.showDynamicRules = function () {
        ngDialog.openConfirm({
          template: 'views/templates/dialog/widget/add-rule-property.html',
          controller: 'RulesPropertyDialog',
          className: 'ngdialog-theme-default ngdialog-schedules ngdialog-rule-property',
          data: {
            subGroups: scope.options,
            property_filters: scope.lookup_filters
          },
          showClose: false
        }).then(function (data) {
          if (data) {
            scope.lookup_filters = data;
          }
          if (scope.lookup_filters.length === 0) {
            FilterService.removeFilter(scope.filter);
          }
          else {
            FilterService.setFilter(scope.filter, scope.lookup_filters);
          }
        });
      };


      scope.$watch('lookup_filters', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue) || !scope.init) {
          scope.ngModelCtrl.$setViewValue(newValue);
          if (scope.filter) {
            FilterService.setFilter(scope.filter, scope.lookup_filters);
          }
          var values = [];
          angular.forEach(scope.lookup_filters, function(filter) {
            values.push(filter.field);
          });
          scope.value = values.join(',');
          scope.init = true;
        }
      });

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {
          return true;
        }
        return !isEmpty(modelValue);
      };

    }
  };
};

var RulesPropertyDialog = function($scope, FormErrorsService, ReportService, FieldService) {
  $scope.subGroups = angular.copy($scope.ngDialogData.subGroups);
  $scope.property_filters = angular.copy($scope.ngDialogData.property_filters);
  $scope.amenitiesFields = [];
  $scope.validSubGroups = [];
  $scope.lookupTypesArray = [];

  $scope.conditions = ReportService.CONDITIONS;
  $scope.lookupTypes = ReportService.LOOKUP_TYPES;

  angular.forEach($scope.subGroups, function(subgroup) {
    if (subgroup.group) {
      if ((subgroup.group.id != 1) || !_.contains(['property_address', 'working_days'], subgroup.key)) {
        $scope.validSubGroups.push(subgroup);
      }
    }
    else {
      $scope.validSubGroups.push(subgroup);
    }
  });

  $scope.initFilters = function() {
    angular.forEach($scope.property_filters, function(property_filter, index) {
      if (!isNull(property_filter.subgroup)) {
        $scope.onGroupChange(index, true);
      }
    });
  };


  $scope.onGroupChange = function(index, noCancel) {
    if (!$scope.amenitiesFields[index]) {
      $scope.amenitiesFields.push([]);
    }
    var subgroup = $scope.property_filters[index].subgroup ? $scope.property_filters[index].subgroup : null;
    FieldService.getlist({disable_pagination:true, summary:true, subgroup: subgroup }, (noCancel || !subgroup)).then(function(data){
      $scope.amenitiesFields[index] = data.results ? data.results : data;
      if ($scope.property_filters[index].field) {
        $scope.onFieldChange(index);
      }
    });
  };

  $scope.onFieldChange = function(index) {
    if (!$scope.lookupTypesArray[index]) {
      $scope.lookupTypesArray.push([]);
    }
    $scope.lookupTypesArray[index] = $scope.getLookupTypes(index);
    $scope.initLookupType(index, $scope.lookupTypesArray[index]);
  };

  $scope.addNew = function() {
    $scope.property_filters.push({
      subgroup: null,
      field: null
    });
  };

  $scope.getFieldType = function(index) {
    var propertyField = $scope.getField(index);
    if (!propertyField) {
      return '';
    }
    var type = propertyField.type;
    if ((propertyField.type === 'text') &&
      (propertyField.data && propertyField.data.options && (propertyField.data.options.length > 0))) {
      type = 'select';
    }
    return type;
  };

  $scope.toggleFilter = function (data) {
    angular.forEach($scope.property_filters, function(property_filter) {
      if (property_filter.field == data.id) {
        property_filter.id = data.id;
        property_filter.key = data.key;
        property_filter.name = data.name;
      }
    });
  };

  $scope.getLookupTypes = function(index) {
    var array = [];
    angular.forEach($scope.lookupTypes, function(type){
      switch ($scope.getFieldType(index)){
        case 'text':
          if (_.contains([ReportService.LOOKUP_TYPE_EQ, ReportService.LOOKUP_TYPE_CONTAINS],type.id)) {
            array.push(type);
          }
          break;
        case 'bool':
        case 'select':
          if (_.contains([ReportService.LOOKUP_TYPE_EQ],type.id)) {
            array.push(type);
          }
          break;
        case 'integer':
          if (_.contains([ReportService.LOOKUP_TYPE_EQ, ReportService.LOOKUP_TYPE_GT, ReportService.LOOKUP_TYPE_GTE,
            ReportService.LOOKUP_TYPE_LT, ReportService.LOOKUP_TYPE_LTE],type.id)) {
            array.push(type);
          }
          break;
      }
    });
    return array;
  };

  $scope.initLookupType = function (index, lookupTypes) {
    if (isNull($scope.property_filters[index].lookup_type)) {
      if (lookupTypes.length > 0){
        $scope.property_filters[index].lookup_type = lookupTypes[0].id;
      }
    }
  };

  $scope.getField = function(index) {
    var field = null;
    if ($scope.amenitiesFields[index]) {
      angular.forEach($scope.amenitiesFields[index], function(amenity) {
        if (amenity.id == $scope.property_filters[index].field) {
          $scope.toggleFilter(amenity);
          field = amenity;
        }
      });
    }
    return field;
  };

  $scope.deleteFilter = function(index) {
    if ($scope.property_filters[index]) {
      $scope.property_filters.splice(index,1);
      $scope.initFilters();
    }
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      return;
    }
    $scope.confirm($scope.property_filters);
  };

  $scope.cancel = function () {
    $scope.closeThisDialog();
  };

  if ($scope.property_filters.length > 0) {
    $scope.initFilters();
  }
  else {
    $scope.property_filters.push({});
  }

};

app.directive('rulePropertySelector', ['ngDialog', 'FilterService', 'FieldService', RulePropertySelector]);
app.controller('RulesPropertyDialog', ['$scope', 'FormErrorsService', 'ReportService', 'FieldService', RulesPropertyDialog]);
